import { Action } from '@ngrx/store';

export enum UserDataActionTypes {
    SetUserName = '[USER_DATA] Set Username',
    SetFullUserName = '[USER_DATA] Set Full Username',
    ClearUserName = '[USER_DATA] Clear Username',
}

export class SetUserName implements Action {
    readonly type = UserDataActionTypes.SetUserName;

    constructor(public payload: { username: string }) {}
}

export class SetFullUserName implements Action {
    readonly type = UserDataActionTypes.SetFullUserName;

    constructor(public payload: { username: string }) {}
}

export class ClearUserName implements Action {
    readonly type = UserDataActionTypes.ClearUserName;
    constructor() {}
}

export type UserDataActions = SetUserName | ClearUserName | SetFullUserName;
